import { TelegramSVG, VkSVG } from '@sbercloud/uikit-product-icons';
import { ButtonTonal } from '@snack-uikit/button';
import { Typography } from '@snack-uikit/typography';
import { useWindowWidth } from 'src/hooks/useWindowWidth';
import { ClickAnalyticsType } from 'src/types';

import s from './SubscribeSocialBanner.module.scss';

export function SubscribeSocialBanner({
  clickAnalytics,
}: {
  clickAnalytics: (variables: ClickAnalyticsType) => void;
}) {
  const { getAdaptiveSizeTypography } = useWindowWidth();

  return (
    <div className={s.root}>
      <div className={s.header}>
        <Typography
          tag="div"
          family="sans"
          className={s.title}
          {...getAdaptiveSizeTypography({
            desktop: { purpose: 'title', size: 'l' },
            tablet: { purpose: 'title', size: 'm' },
          })}
        >
          Подпишитесь на Cloud.ru
        </Typography>

        <Typography
          tag="div"
          family="sans"
          className={s.text}
          {...getAdaptiveSizeTypography({
            desktop: { purpose: 'body', size: 'l' },
            tablet: { purpose: 'body', size: 'm' },
          })}
        >
          Мы делимся полезным контентом и новостями в соцсетях
        </Typography>
      </div>

      <img
        loading="lazy"
        src="https://cdn.cloud.ru/backend/images/subscribe_social_banner_media.png"
        alt="media"
        className={s.media}
      />

      <div className={s.soc}>
        <ButtonTonal
          label="Вконтакте"
          href="https://vk.com/cloudruprovider"
          target="_blank"
          appearance="neutral"
          icon={<VkSVG />}
          onClick={() => {
            clickAnalytics({
              action: `https://vk.com/cloudruprovider`,
              clickZone: 'body',
              clickElement: 'button',
              clickContent: 'Вконтакте',
              uniqueId: `subscribe-soc-button-vk`,
              transitionType: 'outside-link',
              clickZoneCategory: 'site-body',
              transitionUrl: `https://vk.com/cloudruprovider`,
              transitionTypeMetrics: 'external',
            });
          }}
        />
        <ButtonTonal
          label="Telegram"
          href="https://t.me/cloudruprovider"
          target="_blank"
          appearance="neutral"
          icon={<TelegramSVG />}
          onClick={() => {
            clickAnalytics({
              action: `https://t.me/cloudruprovider`,
              clickZone: 'body',
              clickElement: 'button',
              clickContent: 'Telegram',
              uniqueId: `subscribe-soc-button-telegram`,
              transitionType: 'outside-link',
              clickZoneCategory: 'site-body',
              transitionUrl: `https://t.me/cloudruprovider`,
              transitionTypeMetrics: 'external',
            });
          }}
        />
      </div>
    </div>
  );
}
